import { createSelector } from 'reselect'
// import { List } from 'immutable'

const positionSelector = state => state.get('position')

export const getIsFetching = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionCreate.isFetching
    || position.positionEdit.isFetching
    || position.positionDeactivate.isFetching
    || position.positionGet.isFetching
    || position.positionList.isFetching
    || position.positionExport.isFetching
    || position.positionImport.isFetching
  }
)
export const getCreatePositionData = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionCreate
  }
)
export const getEditPositionData = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionEdit
  }
)
export const getDeactivatePositionData = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionDeactivate
  }
)
export const getGetPositionData = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionGet.position
  }
)
export const getListPosition = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionList.position
  }
)
export const getExportURL = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionExport.url
  }
)
export const getImportResult = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return position.positionImport.importResult
  }
)
export const redirectPosition = createSelector(
  positionSelector,
  positionImmutable => {
    const position = positionImmutable.toJS()
    return ({
      redirect: (position.positionCreate.redirect
      || position.positionEdit.redirect
      || position.positionDeactivate.redirect
      || position.positionGet.redirect
      || position.positionList.redirect
      || position.positionExport.redirect
      || position.positionImport.redirect),
      isAuthenticated: (position.positionCreate.isAuthenticated
      || position.positionEdit.isAuthenticated
      || position.positionDeactivate.isAuthenticated
      || position.positionGet.isAuthenticated
      || position.positionList.isAuthenticated
      || position.positionExport.isAuthenticated
      || position.positionImport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/position/position-selector.js